export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('scroll-into-view', {
        mounted(el) {
            const handler = () => {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
            };
            el.__scrollHandler = handler;
            el.addEventListener('focus', handler);
        },
        unmounted(el) {
            el.removeEventListener('focus', el.__scrollHandler);
        }
    });
});
